import { defineNuxtPlugin, useRouter, useScript, useCoreConfig, useVisitorIdCookie, useUserInfo, watch } from '#imports'

export default defineNuxtPlugin({
    name: 'sift',
    parallel: true,
    setup() {
        const { sift } = useCoreConfig()

        if (!sift.enabled || !sift.beaconKey) return

        window._sift = window._sift || []

        const { visitorIdCookie } = useVisitorIdCookie()
        const { isLoggedIn, data } = useUserInfo()

        const userId = () => (isLoggedIn.value && data.value?.customerNumber ? data.value.customerNumber : '')

        window._sift.push(['_setAccount', sift.beaconKey])
        window._sift.push(['_setSessionId', visitorIdCookie.value ?? ''])
        window._sift.push(['_setUserId', userId()])
        window._sift.push(['_trackPageview'])

        watch(isLoggedIn, () => {
            window._sift.push(['_setUserId', userId()])
        })

        useRouter().afterEach(() => {
            window._sift.push(['_trackPageview'])
        })

        // Deferred beacon load; VITEST-skipped like gtm.ts (onNuxtReady fires after test teardown).
        if (!import.meta.env.VITEST) {
            useScript({
                src: 'https://cdn.sift.com/s.js',
                async: true,
            }, {
                trigger: 'onNuxtReady',
            })
        }
    },
})
